module.exports = __webpack_public_path__ + "static/media/Environment.9aa49831.svg";